import axios from "axios";

// You can use your own logic to set your local or production domain

const baseDomain = process.env.VUE_APP_BASE_API;
const baseURL = `${baseDomain}`;

const userInfoLocalStorage = localStorage.getItem("token");

const API = axios.create({
  baseURL: baseURL,
});

API.interceptors.request.use(
  (config) => {
    const community = localStorage.getItem("community");

    if (community) {
      config.headers["community-name"] = community;
    }
    return config;
  },

  (error) => Promise.reject(error)
);

export default API;
